import { Key } from 'react';
import Animated from 'react-native-reanimated';
import { GetProps, View } from 'tamagui';

export type AnimatedViewProps = Omit<GetProps<typeof AnimatedView>, 'key' | 'ref'> &
  Pick<GetProps<typeof Animated.View>, 'ref'> & {
    key?: Key;
  };

export const AnimatedView = Animated.createAnimatedComponent(View);
